<ng-container>
  <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 row m-0 fund-padding">
    <div class="col-md-9 col-sm-12 col-lg-9 col-xl-9 col-xs-9 selectBy-label-padding">
      <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedTabChange)="tabChange($event)">
        <mat-tab label="Investment Summary" #capitalDemandInvestment></mat-tab>
        <mat-tab label="Segment Owners" #capitalDemandOwners></mat-tab>
        <mat-tab label="OT Labor Proposal" #otProposal></mat-tab>
        @if (userWithAccess) {
        <mat-tab label="Hierarchy Mismatch" #hierarchyMismatch></mat-tab>
        <mat-tab label="Bulk Edit" #bulkEdit></mat-tab>
        }
      </mat-tab-group>
    </div>
    <div class="stk-nav col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xs-3 p-0">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb breadcrumb-rightAlign" style="margin-bottom: 0px; padding: 1.5% 0px 0px 0px;">
          <li class="breadcrumb-item"><a class="breadcrumb-home" [routerLink]="['/landing-page']">Home</a></li>
          <li class="breadcrumb-item active" aria-current="page">Capital Demand</li>
          <div>
            <button
              [attr.Pixel-tracking]="true"
              [attr.Pixel-title]="'Documentation'"
              class="breacrum-info-button uitk-icon uitk-icon-info_hollow health md-icon for-media excelandinfo-Icon-font info-icon"
              matTooltipPosition="left"
              title="Info"
              (click)="showDoc()"
            ></button>
          </div>
        </ol>
      </nav>
    </div>
  </div>

  <div>
    @if (capitalDemandInvestment?.isActive) {
    <div class="capital-demand-tabs" [ngStyle]="{ background: selectedIndex === 0 ? 'none' : 'none' }">
      @if (checked) {
      <app-capital-investment-summary-leader
        (toggleChanged)="toggleSelectionChanged($event)"
      ></app-capital-investment-summary-leader>
      } @if (!checked) {
      <app-capital-maintenance
        (toggleChanged)="toggleSelectionChanged($event)"
        [clearFilters]="clearFilters"
        [capitalDemandRecords]="capitalDemandRecords"
      ></app-capital-maintenance>
      }
    </div>
    } @if (capitalDemandOwners?.isActive) {
    <div class="capital-demand-tabs">
      <div class="uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
        <div class="uitk-c-card">
          <div class="uitk-l-grid__col--12 stk-container-tabl-header">
            <div class="table-header-icons">
              <div class="table-search col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-6">
                <mat-form-field class="data-filter cd-table-search" appearance="outline" style="padding: 0px;">
                  <input
                    matInput
                    type="text"
                    class="capability-search"
                    [(ngModel)]="searchString"
                    placeholder="Search Funding Segment ID/Name/Owner/Delegate"
                    (keyup)="searchDataSet($event)"
                  />
                  <img src="../../../../assets/images/searchicon.png" class="search-img" />
                </mat-form-field>
              </div>
              &nbsp;
              <div class="table-header-icons table-header-icons-buttons col-md-8 col-sm-6 col-lg-8 col-xl-8 col-xs-6">
                @if (restrictionEdit) {
                <button
                  class="m-1 mat-mdc-raised-button techops-global-button uitk-c-button uitk-c-button--default  uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                  (click)="AddSegment()"
                >
                  Add
                </button>
                } &nbsp;
                <div class="export-link">
                  <span
                    title="Click to Download"
                    (click)="exportToExcel()"
                    class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <div class="uitk-c-card__content m-0">
            <div class="stk-table-container">
              <ng-container>
                <app-fund-maintenance-table
                  [oldDataSource]="Records"
                  [dataSource]="capitalDemnadList"
                  [searchString]="searchString"
                  (SegmentDeleted)="segemntDelRefrash($event)"
                  (SegmentEditedByIdSubmit)="segmentRefreashData($event)"
                >
                </app-fund-maintenance-table>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
    <div class="capital-demand-tabs" [ngStyle]="{ display: !hierarchyMismatch?.isActive ? 'none' : null }">
      <app-heirarchy-mismatch [tabSwitched]="tabSwitched"></app-heirarchy-mismatch>
    </div>
    <div class="capital-demand-tabs" [ngStyle]="{ display: !bulkEdit?.isActive ? 'none' : null }">
      <app-capitaldemand-bulk-edit></app-capitaldemand-bulk-edit>
    </div>

    <div class="capital-demand-tabs" [ngStyle]="{ display: !otProposal.isActive ? 'none' : null }">
      <app-ot-labor-proposal [tabSwitched]="tabSwitched"></app-ot-labor-proposal>
    </div>
  </div>

  <app-modal
    [maximizable]="true"
    [inViewport]="true"
    #modalAddSegment
    class="modal-demo add-segment-popups"
    (closeModal)="hidepopup('addSegment')"
  >
    <ng-container class="app-modal-header">Add Segment</ng-container>
    <ng-container class="app-modal-body">
      @if (isAddSegment) {
      <app-add-segment (SegmentAdded)="segmentSubmit($event)" [isAddSegment]="isAddSegment"> </app-add-segment>
      }
    </ng-container>
  </app-modal>
</ng-container>
